import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation('common');

  const points = [
    { icon: 'ri-folder-chart-line', text: 'trust.point1' },
    { icon: 'ri-refresh-line', text: 'trust.point2' },
    { icon: 'ri-scales-3-line', text: 'trust.point3' },
    { icon: 'ri-global-line', text: 'trust.point4' },
    { icon: 'ri-award-line', text: 'trust.point5' },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            {t('trust.h2')}
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6">
          {points.map((point, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-5 py-3 bg-background-100 rounded-full border border-background-200"
            >
              <i className={`${point.icon} text-accent-600`} />
              <span className="text-sm font-medium text-foreground-700">{t(point.text)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}